// TIP-493 — render AED amounts with the official Dirham symbol instead of "Dh".
// The SVG inherits the surrounding text color (fill=currentColor) and scales to
// the font size, so it sits inline like a glyph.
import React from "react";
import { ReactComponent as DirhamGlyph } from "../../assets/icons/dirham.svg";
import "./Money.css";

// UAE Central Bank rule: the Dirham symbol must match the height of the figures
// beside it. The figures' visual height is their cap height (~0.72em), so the
// glyph is sized to that and sits on the text baseline — it reads as the same
// height as the digits, not the full em box (which looked oversized). The SVG
// inherits color via currentColor and scales with the surrounding font size.
export const Dirham = ({ className = "" }) => (
  <DirhamGlyph className={`dirham-glyph inline-block shrink-0 ${className}`} aria-label="AED" />
);

const formatNumber = (n) =>
  Math.abs(Number(n) || 0).toLocaleString("en-AE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// the same height as the figures. Negative values render with a leading minus.
export const Aed = ({ value, className = "" }) => (
  <span className={`whitespace-nowrap ${className}`}>
    {Number(value) < 0 && "− "}
    <Dirham className="mr-[0.15em]" />
    {formatNumber(value)}
  </span>
);

export default Aed;
